import { logoutUser } from './logoutUser';

export const handleCouchError = (error: any) => {
	if (error?.status === 401 || error?.status === 403) {
		console.error(`Unauthorized request, logging out. Error: ${error.status}`);

		logoutUser();
	} else {
		console.error('Error occurred:', error);
	}
};
